import { Component, EventEmitter, Input, Output } from '@angular/core';
import { KanbanViewCardI } from '../../models/kanban-view/kanban-viewI';
import { MatCheckbox } from '@angular/material/checkbox';
import * as moment from 'moment';

@Component({
  selector: 'anterasoftware-kanban-view-card',
  templateUrl: './kanban-view-card.component.html',
  styleUrls: ['./kanban-view-card.component.scss']
})
export class KanbanViewCardComponent {
  @Input() public dateFormatString: string = 'YYYY-MM-DD';
  @Input() public timeFormatString: string = 'hh:mm a';

  @Output() public onCardDetailsChange: EventEmitter<any> = new EventEmitter();
  @Output() public onAssignArtwork: EventEmitter<any> = new EventEmitter();
  @Output() public onDeleteArtwork: EventEmitter<any> = new EventEmitter();
  @Output() public onEditArtwork: EventEmitter<any> = new EventEmitter();
  @Output() public pinned: EventEmitter<any> = new EventEmitter();
  @Output() public onOpenRelatedOrderDetailDialog: EventEmitter<any> = new EventEmitter();
  isOverdue = false;
  dueColor: string = '';
  dueFontColor: string = '';

  constructor() { }

  @Input() public cardDetails: KanbanViewCardI = {
    select: false,
    title: '', 
    dueDate: '',
    priority: '',
    orderNumber: [],
    status: '',
    tagList: [],
    smallImg: '',
    bigImg: '',
    id: '',
    estimated: '',
    assignee: '',
    assignedId: '',
    pinned: false,
    workOrderNo: '',
    workOrderId: '',
    designId: ''
  };
  orderNumbers: string = "";

  ngOnInit() {
    
    this.isOverdue = (this.cardDetails.dueDate !== null) && (moment() > moment(new Date(this.cardDetails.dueDate)));

    if(this.cardDetails.orderNumber && this.cardDetails.orderNumber.length > 0) {
      let orderNumbers = this.cardDetails.orderNumber.map((value: any)=>{
        return value.orderNum;
      })
      this.orderNumbers = orderNumbers.toString();
    }
    if (this.cardDetails.dueDate && this.cardDetails.dueDate !== '0000-00-00') {
        let cardDate = moment(this.cardDetails.dueDate).endOf('day');
        let curDate = moment().endOf('day');
        let diff = cardDate.diff(curDate, 'hours');
        switch(true) {
          // red past due or due today
          case diff < 0:
            this.dueColor = 'red';
            this.dueFontColor = '#ffffff';
            break;
          //due today
          case diff == 0:
            this.dueColor = 'orange';
            this.dueFontColor = '#ffffff';
            break;
          // tomorrow
          case diff >= 24 && diff <= 24*2:
            this.dueColor = 'yellow';
            break;
          // this week
          case diff >= 24*2 && diff <= 24*7:
            this.dueColor = 'green';
            this.dueFontColor = '#ffffff';
            break;
          // next week
          case diff >= 24*7 && diff <= 24*14:
            this.dueColor = 'blue';
            this.dueFontColor = '#ffffff';
            break;
          // this month
          case diff >= 24*14 && diff <= 24*30:
            this.dueColor = 'black';
            this.dueFontColor = '#ffffff';
            break;
          default:
            this.dueColor = 'gray';
            break;              
        }
    }
  }

  /**
   * Emits event on check box select.
   * 
   * @returns {void}
   */
  public onCheckBoxSelected(event: MatCheckbox): void {
    this.onCardDetailsChange.emit(this.cardDetails);
  }

  public assignArtwork(artwork:any) {
    this.onAssignArtwork.emit(artwork);
  }

  public deleteArtwork(artwork:any) {
    this.onDeleteArtwork.emit(artwork);
  }

  public editArtwork(artwork:any) {
    this.onEditArtwork.emit(artwork);
  }

  /* public onToggle(event: MatCheckbox, swimLaneIndex: number){
    this.swimLaneList[swimLaneIndex]?.cards.forEach((card: KanbanViewCardI) => card.select = event.checked);
    this.selectClicked.emit(this.swimLaneList);
  } */

  onPin(ev: any) {
    ev.stopPropagation();
    this.cardDetails.pinned = !this.cardDetails.pinned;
    this.pinned.emit(this.cardDetails);
  }
  public getDateFormat(date :any, includeTime = false, excludeTime = false, convert = false){
    if(date == null || date == '' || date == '0000-00-00 00:00:00' || date == '0000-00-00' || date == '0000-00-00' || (String(date).indexOf("0000") > -1 && String(date).indexOf("+0000") < 0 )){
        return '';
    }
    if(convert){
      if(includeTime){
    return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString);
    }
      }          
    }else{
      if(includeTime){
    return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(date).format(this.dateFormatString);
    }
      }      
    }
  }

  openRelatedOrderDetailDialog(orderId: string, cardDetails: any) {
    let data = {
      orderId: orderId,
      cardDetails: cardDetails
    }
    this.onOpenRelatedOrderDetailDialog.emit(data);
  }
}
